// ---------------------------------------------------------------------------
//          Money format handler
// ---------------------------------------------------------------------------
var currencySymbol = $('.cstm-summary-cart-buttons').find('.cstm-summary').find('.cstm-summary-item-price').data('currency-symbol');
Shopify.money_format = currencySymbol+"{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
// ---------------------------------------------------------------------------



$(document).ready(function() {

  $('.add-beads-mobile').click(function(){
    $('.cstm-mobile-slide').addClass("cstm-active");
  });
  $('.cstm-mobile-slide-header').click(function(){
    $('.cstm-mobile-slide').removeClass("cstm-active");
  });
  
  var cartSection = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  
  // mm width size of Main Product
  var mainProdWidth = Number($('.cstm-product-filter').find('[name="size"]').find('option:selected').attr('data-width')) || 20;
  console.log('mainProdWidth',mainProdWidth);
  mainProdWidth = mainProdWidth * 10;
  
  var option_count = $('.cstm-product-filter[data-product-options] .cstm-filter-dropdown').length;
  option_count = option_count - 1;

  if( $('.cstm-product-list .cstm-product-list-item').length == 0 ){
    $('.build-your-own-main .cstm-product-list').hide();
  }
  
  // Change every dropdown options
  $('.cstm-filter-dropdown').change(function(){
    // console.log('this=>',$this.val());
    var option_title = '';
    $('.cstm-product-filters .cstm-product-filter[data-product-options] .cstm-filter-dropdown').each(function(i,e){
      var $this = $(this);
      var $this_option = $this.val();
      console.log('this=>',$this.val());
      if ( i < option_count ){
        option_title += $this_option+' / ';
      } else {
        option_title += $this_option;
      }
    });
    console.log('option_title =>',option_title);
    // Change main select and get Curr-VID trigger
    $('.cstm-product-grid.grid-right').find('.cstm-product-filters').find('select[name="id"] option[data-title="'+option_title+'"]').prop('selected', 'selected').change();
    localStorage.removeItem("itemsArray");
    localStorage.removeItem("beaditemsArray");
  });

  //default first variant option set image
    var $mainImage = $('.cstm-product-grid.grid-right').find('.cstm-product-filters').find('select[name="id"]').find('option:selected').attr('data-varimg');
    
    $('.cstm-product-grid.grid-right').find('.cstm-product-grid-wrap').find('.cstm-product-stage').find('.cstm-product-stag-wrap').find('img[data-main-product-image]').attr('src',$mainImage);
  
  // Get Main Select no-js hidden dropdown
  $('.cstm-product-grid.grid-right').find('.cstm-product-filters').find('select[name="id"]').change(function(){
    var $currMainVID = $(this).val();
    
    // Set main prod price to attr
    var $mainPrice = $(this).find('option:selected').data('price');
    $(this).closest('.cstm-product-grid-wrap').find('.cstm-summary-cart-buttons').attr('data-main-price',$mainPrice);
    $(this).closest('.cstm-product-grid-wrap').find('.cstm-summary-cart-buttons').find('.cstm-summary-item-price').text(Shopify.formatMoney($mainPrice,Shopify.money_format));

    // Set Add to car button : Available?
    var $mainAvail = $(this).find('option:selected').attr('data-var-avail');
    if( $mainAvail == 'false' ){
      $(this).closest('.cstm-product-grid-wrap').find('.cstm-summary-cart-buttons').find('.cstm-cta-buttons').find('button').attr('disabled','disabled');
    } else {
      $(this).closest('.cstm-product-grid-wrap').find('.cstm-summary-cart-buttons').find('.cstm-cta-buttons').find('button').removeAttr('disabled');
    }

    // Set main image
    var $mainImage = $(this).find('option:selected').attr('data-varimg');
    
    $(this).closest('.cstm-product-grid-wrap').find('.cstm-product-stage').find('.cstm-product-stag-wrap').find('img[data-main-product-image]').attr('src',$mainImage);
    
    // Set the Main Prod width
    mainProdWidth = $('.cstm-product-filter').find('[name="size"]').find('option:selected').attr('data-width') || 20;
    mainProdWidth = mainProdWidth * 10;
    
    if(productsJSON.length > 0){
      create_product_list(productsJSON);
    }
  });



  // ADD Beads button click +
  var totalBeadWidth = 0;
  var productsJSON = [];


      // Retrieve the stored data from localStorage
    const storedItems = JSON.parse(localStorage.getItem('itemsArray'));

   
    if(storedItems){
      productsJSON = storedItems;

       // Retrieve the stored data from localStorage
      const beadstoredItems = JSON.parse(localStorage.getItem('beaditemsArray'));
       // Create Beads Images list
      if(beadstoredItems){
        create_beads_Images_list(productsJSON, beadstoredItems);
      }else{
        create_beads_Images_list(productsJSON);
      }
    

    // Create the beads structure
    create_product_list(productsJSON);    
    }
 
  $('.add-item-btn').click(function(){
    
    //AK custom
    var box_length = $('.cstm-product-stag-wrap .cstm-product-beads-wrap .custom-rotate-img').length;
    if(box_length > 0){
      var beads_style_Array = [];
      $('.cstm-product-stag-wrap .cstm-product-beads-wrap .custom-rotate-img').each(function(){
        var data_vid = $(this).attr('data-vid');
        var top = $(this).css('top');
        var left = $(this).css('left');
        var transform = $(this).css('transform'); 

        // Create an object with the properties
        var beadData = {
            data_vid: data_vid,
            top: top,
            left: left,
            transform: transform
        };
        // Push the object into the array
        beads_style_Array.push(beadData);
      });
    }
    //AK end custom
    
    var vid = $(this).closest('.product-grid-item').data('vid');
    var qty = 1;
    var price = $(this).closest('.product-grid-item').data('price');
    // var imageUrl = $(this).closest('.grid-item-image-block').find('.grid-item-image-wrap').find('img').attr('src');
    var imageUrl = $(this).closest('.grid-item-image-block').find('.grid-item-image-wrap').find('img').attr('data-img-src');
    var imageAlt = $(this).closest('.grid-item-image-block').find('.grid-item-image-wrap').find('img').attr('alt');
    var collType = $(this).closest('.product-grid-item').data('coll-type');
    var beadWidth = parseFloat($(this).closest('.product-grid-item').data('mm-size'));
    
    totalBeadWidth += beadWidth;

    var curtime = Date.now();
    
    // Create Main JSON
    if( totalBeadWidth <= mainProdWidth){
      productsJSON.push({'id':vid,'curtime':curtime, 'qty':qty, 'price':price, 'image':imageUrl, 'alt':imageAlt, 'colltype':collType, 'beadwidth':beadWidth, 'align':'' });
    } else {
      totalBeadWidth -= beadWidth;
      productsJSON.push({'id':vid,'curtime':curtime, 'qty':qty, 'price':price, 'image':imageUrl, 'alt':imageAlt, 'colltype':collType, 'beadwidth':beadWidth, 'align':'origin-center' });
      console.log('=== Width is full ====');
    }

     // max limit set for prod type
    var totItems = productsJSON.length;
   
    var prodtype = $('.cstm-filter-dropdown').attr('id');
console.log('prodtype', prodtype);
    if(prodtype == 'bracelet-anklet-for-custom' && totItems > 40){
      console.log('=== Width is full ====');
      return false;
    }
    if(prodtype == 'necklace-for-custom' && totItems > 70){
      console.log('=== Width is full ====');
      return false;
    }
    if(prodtype == 'earring' && totItems > 10){
      console.log('=== Width is full ====');
      return false;
    }
    
    
    var remWidth = mainProdWidth - totalBeadWidth; // 3
    
    $('.accordion-product-grid').each(function(i,e){
      // console.log(i);  console.log(e);
      var $elem = $(this);
      var this_size = $elem.data('mm-size');      // 4
      // 3 >= 4
      if(remWidth < this_size){
        $elem.find('.product-grid-item').find('.add-item-btn').addClass('hide');
      }
    });
   

    // Check the remaining avail width to fill in main prod
    check_remaining_width(mainProdWidth,totalBeadWidth);

    // Create Beads Images list
      create_beads_Images_list(productsJSON,beads_style_Array);
    

    // Create the beads structure
    create_product_list(productsJSON);    
  });


  // Check the remaining avail width to fill in main prod
  function check_remaining_width(mainProdWidth,totalBeadWidth){
    var currProdWidth = mainProdWidth;
    var totalBeadWidth = totalBeadWidth;
    var remWidth = currProdWidth - totalBeadWidth; // 3
    
    // Loop throught each bead type for it's width
    $('.accordion-product-grid').each(function(i,e){
      // console.log(i);  console.log(e);
      var $elem = $(this);
      var this_size = $elem.data('mm-size');      // 4
      // console.log('this_size =>',this_size);  // 3 >= 4      
      if(remWidth < this_size){
        // $elem.find('.product-grid-item').find('.add-item-btn').addClass('hide');
        $elem.closest('.customize-product-grid').find('.cstm-product-grid.grid-right').find('.cstm-product-stage').addClass('limit-full');
      } else {
        $elem.find('.product-grid-item').find('.add-item-btn').removeClass('hide');
        $elem.closest('.customize-product-grid').find('.cstm-product-grid.grid-right').find('.cstm-product-stage').removeClass('limit-full');
      }
    });
  }
  
  function create_beads_Images_list(productsJSON,beads_style_Array){
    var beads_list_json = productsJSON
    var $beads_html='';
    if(beads_list_json.length > 0){
      $(beads_list_json).each(function(i, e){
        var j = i + 1;
      
        // Find the matching object in beads_style_Array
        if(beads_style_Array){
          // Save the array to localStorage
        localStorage.setItem('beaditemsArray', JSON.stringify(beads_style_Array));
          
          var matchingBead = beads_style_Array.find(bead => bead.data_vid == e.curtime);
            if(matchingBead){
                var top = matchingBead.top;
                var left = matchingBead.left;
                var transform = matchingBead.transform;
                // Create the style string conditionally
                var styleString = 'background-image: url(' + e.image + ');';
                if (top) {
                    styleString += ' top: ' + top + ';';
                }
                if (left) {
                    styleString += ' left: ' + left + ';';
                }
                if (transform) {
                    styleString += ' transform: ' + transform + ';';
                }
  
              // Create the HTML string with the properties
              $beads_html+='<div id="draggable'+j+'" data-id="'+j+'" data-vid="'+e.curtime+'" class="box custom-rotate-img custom-rotate-img_'+i+' type_'+e.colltype+' '+ e.align+'" style="' + styleString + '">';
              $beads_html+='</div>';
              
            }else{
              $beads_html+='<div id="draggable'+j+'" data-id="'+j+'" data-vid="'+e.curtime+'" class="box custom-rotate-img custom-rotate-img_'+i+' type_'+e.colltype+' '+e.align+'" style="background-image: url('+e.image+');">';
              $beads_html+='</div>';
            }
        }else{
          $beads_html+='<div id="draggable'+j+'" data-id="'+j+'" data-vid="'+e.curtime+'" class="box custom-rotate-img custom-rotate-img_'+i+' type_'+e.colltype+' '+e.align+'" style="background-image: url('+e.image+');">';
          $beads_html+='</div>';
        }
        
      });
    }
    // Append $beads_html HTML
    //$('.cstm-product-footer').find('.cstm-footer-info').find('.cstm-product-list').html($beads_html);
    $('.cstm-product-grid.grid-right').find('.cstm-product-stage').find('.cstm-product-stag-wrap').find('.cstm-product-beads-wrap').html($beads_html);
  }
  
  
  function create_product_list(productsJSON){
    
    var prod_list = productsJSON;
    var $prod_html='';
    var summary_item_html = '';
    var $total = 0;
    $total = parseInt($('.cstm-summary-cart-buttons').attr('data-main-price'));
    var $remove_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none"> <g clip-path="url(#clip0_1817_83)"> <path d="M11.2658 12.4307L8.64058 10.0093L6.21917 12.6346C6.09073 12.7738 5.91223 12.8563 5.72294 12.864C5.53366 12.8716 5.34909 12.8038 5.20984 12.6753C5.07058 12.5469 4.98806 12.3684 4.98041 12.1791C4.97277 11.9898 5.04063 11.8053 5.16907 11.666L7.59048 9.04077L4.96524 6.61935C4.82599 6.49092 4.74347 6.31242 4.73582 6.12313C4.72818 5.93385 4.79604 5.74928 4.92448 5.61003C5.05292 5.47077 5.23141 5.38825 5.4207 5.3806C5.60999 5.37296 5.79456 5.44082 5.93381 5.56926L8.55904 7.99067L10.9805 5.36543C11.1089 5.22618 11.2874 5.14366 11.4767 5.13601C11.666 5.12837 11.8505 5.19623 11.9898 5.32467C12.129 5.45311 12.2116 5.6316 12.2192 5.82089C12.2269 6.01018 12.159 6.19475 12.0306 6.334L9.60914 8.95923L12.2344 11.3806C12.3736 11.5091 12.4562 11.6876 12.4638 11.8769C12.4714 12.0662 12.4036 12.2507 12.2751 12.39C12.1467 12.5292 11.9682 12.6118 11.7789 12.6194C11.5896 12.627 11.4051 12.5592 11.2658 12.4307Z" fill="white"/> </g> <defs><clipPath id="clip0_1817_83"><rect width="11.4286" height="11.4286" fill="white" transform="translate(8.27393 0.925446) rotate(42.6872)"/></clipPath></defs> </svg>';

   
    if(prod_list.length > 0){
      
      var totCubes = prod_list.filter(function(o) { return o.colltype == 'cubes' }).length;
      var totShrooms = prod_list.filter(function(o) { return o.colltype == 'shrooms' }).length;
      var totCapsules = prod_list.filter(function(o) { return o.colltype == 'capsules' }).length;
      var totCharms = prod_list.filter(function(o) { return o.colltype == 'charms' }).length;
      // console.log('totCubes=',totCubes);

      $('.cstm-product-footer').find('.cstm-footer-info').find('.cstm-product-list').html('');
      
      $('.cstm-product-list').show();
      $('.cstm-product-empty-text').hide();

      
      
      $(prod_list).each(function(i, e){

        $prod_html+='<div class="cstm-product-list-item" data-index="'+i+'" data-vid="'+e.curtime+'">';
        $prod_html+='<img alt="'+e.alt+'" src="'+e.image+'"/>';
        $prod_html+='<button type="button" class="btn cstm-product-remove">';
        $prod_html+='<span>';
        $prod_html+=$remove_icon;
        $prod_html+='</span>';
        $prod_html+='</button>';
        $prod_html+='</div>';
      

        // Add item price to total
        $total = $total + parseInt(e.price);
      });
      
      setTimeout(function(){
  
        // Enable slick slider on beads
        if(prod_list.length > 3){
          if( $('.build-your-own-main .cstm-product-list.slick-initialized').length > 0 ){
            $('.build-your-own-main .cstm-product-list').slick('destroy');
            $('.build-your-own-main .cstm-product-list').html('');
            //$('.build-your-own-main .cstm-product-list').slick('unslick').slick('reinit').slick({
            $('.cstm-product-footer').find('.cstm-footer-info').find('.cstm-product-list').html($prod_html);
            $('.build-your-own-main .cstm-product-list').slick({
              dots: false,
              infinite: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true
            });
          } else {
            $('.cstm-product-footer').find('.cstm-footer-info').find('.cstm-product-list').html($prod_html);
            $('.build-your-own-main .cstm-product-list').slick({
              dots: false,
              infinite: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true
            });
          }
        } else {
          $('.cstm-product-footer').find('.cstm-footer-info').find('.cstm-product-list').html($prod_html);
        }
      },100);

      // All beads qty and title to summary section      
      if(totCubes > 0){
        //$('.cstm-summary-cart-buttons').find('.cstm-summary').find('.cstm-summary-item').html(totCubes);
        summary_item_html+='<span class="cstm-summary-item">+ </span>';
        summary_item_html+='<span class="cstm-summary-item">'+totCubes+' Cubes</span>';
      }
      if(totShrooms > 0){
        summary_item_html+='<span class="cstm-summary-item"> + </span>';
        summary_item_html+='<span class="cstm-summary-item">'+totShrooms+' Shrooms</span>';
      }
      if(totCapsules > 0){
        summary_item_html+='<span class="cstm-summary-item"> + </span>';
        summary_item_html+='<span class="cstm-summary-item">'+totCapsules+' Capsules</span>';
      }
      if(totCharms > 0){
        summary_item_html+='<span class="cstm-summary-item"> + </span>';
        summary_item_html+='<span class="cstm-summary-item">'+totCharms+' Charms</span>';
      }
      $('.cstm-summary-cart-buttons').find('.cstm-summary').find('.summary-items').html(summary_item_html);
      
      // Total Price
      $('.cstm-summary-cart-buttons').find('.cstm-summary').find('.cstm-summary-item-price').text(Shopify.formatMoney($total,Shopify.money_format));

      // call remove function
      setTimeout(function(){
        removeBeads();
      },200);

      //setTimeout(function(){

      const draggable = true;
      const throttleDrag = 1;
      const edgeDraggable = false;
      const startDragRotate = 0;
      const throttleDragRotate = 0;
      const scalable = false;
      const keepRatio = false;
      const throttleScale = 0;
      const renderDirections = ["nw","n","ne","w","e","sw","s","se"];
      const rotatable = true;
      const throttleRotate = 0;
      const rotationPosition = "top";
      const element$0 = document.querySelector(`.cstm-product-beads-wrap`);
      let selectoRef = null;
      const moveable$0 = new Moveable(element$0, {
          target: ".cstm-product-stag-wrap .box",
          individualGroupable: true,
          draggable: draggable,
          throttleDrag: throttleDrag,
          edgeDraggable: edgeDraggable,
          startDragRotate: startDragRotate,
          throttleDragRotate: throttleDragRotate,
          scalable: scalable,
          keepRatio: keepRatio,
          throttleScale: throttleScale,
          rotatable: rotatable,
          throttleRotate: throttleRotate,
          rotationPosition: rotationPosition
      });
      moveable$0.on("drag", e => {
          e.target.style.transform = e.transform;

          var box_length = $('.cstm-product-stag-wrap .cstm-product-beads-wrap .custom-rotate-img').length;
          var beads_style_Array = [];
          if(box_length > 0){
            $('.cstm-product-stag-wrap .cstm-product-beads-wrap .custom-rotate-img').each(function(){
              var data_vid = $(this).attr('data-vid');
              var top = $(this).css('top');
              var left = $(this).css('left');
              var transform = $(this).css('transform'); 
      
              // Create an object with the properties
              var beadData = {
                  data_vid: data_vid,
                  top: top,
                  left: left,
                  transform: transform
              };
            
              // Push the object into the array
                beads_style_Array.push(beadData);
                // Save the array to localStorage
                localStorage.setItem('beaditemsArray', JSON.stringify(beads_style_Array));
            });
          }
        
          
      });
      moveable$0.on("rotate", e => {
          e.target.style.transform = e.drag.transform;
      });

      selectoRef = new Selecto({
            container: element$0,
            dragContainer: element$0,
            selectableTargets: [".box"],
            hitRate: 0,
            selectByClick: true,
            selectFromInside: false,
            toggleContinueSelect: ["shift"],
            ratio: 0
        });


        function setTargets(nextTargets) {
            targets = nextTargets;
            moveable$0.target = targets;
        }

        moveable$0.on("render", e => {
            e.target.style.cssText += e.cssText;
        });

        moveable$0.on("drag", (e) => {
         e.target.style.transform = e.transform;
        });

        selectoRef.on("selectEnd", e => {
            const moveable = moveable$0;
            if (e.isDragStart) {
                e.inputEvent.preventDefault();
                moveable.waitToChangeTarget().then(() => {
                    console.log("W C T");
                    moveable.dragStart(e.inputEvent);
                });
            }
            setTargets(e.selected);
        }); 


      
    } else {
      // Clear Bead slider cstm-product-list div
      $('.cstm-product-list').html('').hide();
      $('.cstm-product-empty-text').show();
      // Clear the summary-items div
      $('.cstm-summary-cart-buttons').find('.cstm-summary').find('.summary-items').html(summary_item_html);
      // Total Price reset with main prod price
      $('.cstm-summary-cart-buttons').find('.cstm-summary').find('.cstm-summary-item-price').text(Shopify.formatMoney($total,Shopify.money_format));
    }

    if(productsJSON.length == 0){
      $("span[id^=item-counter-]").text('');
    }

    var items = [];
    productsJSON.forEach(function(val){
        items.push(val.id);
    });

    var aggregateitems = aggregate(items);

   Object.entries(aggregateitems).forEach(([key, quantity]) => {
     $('#item-counter-'+key).text(quantity);
  });

    
    // Save the array to localStorage
    localStorage.setItem('itemsArray', JSON.stringify(productsJSON));
  }

  function aggregate(array){
    var obj = {};

    array.forEach(function(val){
        if (!obj[val])
            // create new property if property is not found
            obj[val] = 1;
        else
            // increment matched property by 1
            obj[val]++;
    });
    
    return obj;
}

  
  // Slider Remove button click
  function removeBeads(){
    //$('.cstm-product-remove').click(function(){
    $('.cstm-product-list .cstm-product-remove').unbind('click').click(function(e) {
      e.preventDefault();
      // $('.cstm-product-remove').on('click',function(){
      var vid = $(this).closest('.cstm-product-list-item').data('vid');
      var index = $(this).closest('.cstm-product-list-item').data('index');

      var removedBeadWidth = productsJSON[index].beadwidth;

      totalBeadWidth -= removedBeadWidth;

      // Re-set remaining fill width space
      check_remaining_width(mainProdWidth,totalBeadWidth);
      
      productsJSON.splice(index, 1);

      //AK custom
      var box_length = $('.cstm-product-stag-wrap .cstm-product-beads-wrap .custom-rotate-img').length;
      var beads_style_Array = [];
      if(box_length > 0){
        $('.cstm-product-stag-wrap .cstm-product-beads-wrap .custom-rotate-img').each(function(){
          var data_vid = $(this).attr('data-vid');
          var top = $(this).css('top');
          var left = $(this).css('left');
          var transform = $(this).css('transform'); 
  
          // Create an object with the properties
          var beadData = {
              data_vid: data_vid,
              top: top,
              left: left,
              transform: transform
          };
       
          // Push the object into the array
            beads_style_Array.push(beadData);
          
        });
      }
      //AK end custom

      // Re-create Beads Images list
      create_beads_Images_list(productsJSON,beads_style_Array);
      
      // Refresh the beads structure
      create_product_list(productsJSON);
      
    });
   
    
  }
  removeBeads();


  
  // Clear All button click
  $('.cstm-product-footer .button-clear-all').unbind('click').click(function(e) {
    e.preventDefault();    
    // reset Total width
    totalBeadWidth = 0;
    // remove hide from add-button
    $('.accordion-product-grid').find('.product-grid-item').find('.add-item-btn').removeClass('hide');
    // remove all bead images fro Main Image
    $('.cstm-product-grid.grid-right').find('.cstm-product-stag-wrap').find('.cstm-product-beads-wrap').html('');
    //productsJSON = [];
    productsJSON.length = 0;
    localStorage.removeItem("itemsArray");
    localStorage.removeItem("beaditemsArray");
    // Refresh the beads structure
    create_product_list(productsJSON);
  });

  
  
  // Final Bundle - Add to cart button Click
  $('[data-add-to-cart]').click(function(){
    var $this1 = $(this);
    var arr = [];
    var timestamp = Math.round(new Date().getTime()/1000);
    var prop = {};
    
    var pdpID = parseInt($('select[name="id"]').val());
    var pdpQty = 1;

    // Add Main product to Array
    prop = {'_custom_build':'custom-builder'+timestamp,'_main_prod':'Yes'};
    arr.push({'id': pdpID,'quantity':pdpQty,'properties':prop});

    // Add Beads sub-products to Array
    if(productsJSON.length > 0){
      $(productsJSON).each(function(i, e){
        prop = {'_custom_build':'custom-builder'+timestamp};
        arr.push({'id': e.id,'quantity':e.qty,'properties':prop});
      });
    }
    
    var arr_reverse = arr.reverse();
    console.log('arr_reverse=>',arr_reverse);
    
    if(arr_reverse.length > 0){
      let formData = {'items': arr_reverse};
      
      const AddObj = { items: arr_reverse, sections: cartSection.getSectionsToRender().map((section) => section.id), sections_url: window.location.pathname };
      renderCart(AddObj,routes.cart_add_url);
      
    }
    
  });

  // Refresh the cart drawer
  function renderCart(array, url){
    fetch(url, {
      method: 'POST',
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(array)
    })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedData = JSON.parse(state);
      console.log('success-->',parsedData);      
      cartSection.renderContents(parsedData);
      // Clear all after adding to cart
      $('.cstm-product-footer .button-clear-all').trigger('click');
      localStorage.removeItem("itemsArray");
      localStorage.removeItem("beaditemsArray");
      
    }).catch((e) => {
      console.error(e);
    })
    .finally(() => {
      // this.submitButton.classList.remove('loading');
      if (cartSection && cartSection.classList.contains('is-empty')) cartSection.classList.remove('is-empty');
      // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      // this.querySelector('.loading__spinner').classList.add('hidden');
    });
  }

  function closeDrawer(){
    $('[data-close_drawer]').click(function(e){
      e.preventDefault();
      $(this).closest('cart-drawer').removeClass('active');
      $('body').removeClass('overflow-hidden');
    });
  }

  // Final Bundle - Add to cart button Click
  $('[data-buy-now]').click(function(){
    $(this).closest('.cstm-cta-buttons').find('[data-add-to-cart]').trigger('click');
    setTimeout(function(){ location.href='/checkout' },1000);
  });

  
  
  
});
